<template>
  <div>
    <div class="top">
      <Header></Header>
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- <swiper-slide class="video_btn">
          <video muted autoplay src="../../assets/video/7.11h1.mp4" id="video" loop ref="video"></video>
          <div class="move_btn" @click="moveBtn()">
          </div>
        </swiper-slide>-->
        <swiper-slide class="video_btn" style>
          <video muted autoplay="autoplay" id="video" :src="video_url" loop></video>
          <!-- <video muted="muted" autoplay="autoplay" id="video" :src="video_url"></video> -->
          <div class="move_btn" @click="moveBtn()">
            <div class="logo_c"></div>
          </div>
        </swiper-slide>
        <swiper-slide v-for="(item,index) in banner_list" :key="index">
          <a :href="item.link" target="_blank" v-if="item.link">
            <img :src="item.cover_img" width="100%" style="min-height: 100%;" />
          </a>
          <a href="javascript:;" v-else>
            <img :src="item.cover_img" width="100%" style="min-height: 100%;" />
          </a>
        </swiper-slide>

        <!-- <swiper-slide><img src="@/assets/images/banner.jpg" width="100%" style="min-height: 100%;"></swiper-slide> -->

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <template v-if="video_url">
        <transition
          enter-active-class="animate__animated animate__zoomIn "
          leave-active-class="animate__animated animate__zoomOut"
        >
          <div class="movie_v" v-if="show">
            <video
              muted="true"
              autoplay
              id="video"
              controls
              loop
              ref="videoPlayer"
              :src="video_url"
            ></video>
          </div>
        </transition>
        <transition
          enter-active-class="animate__animated animate__zoomIn"
          leave-active-class="animate__animated animate__zoomOut"
        >
          <div class="movie_box" v-if="show">
            <p class="box_close" @click="closeFun()"></p>
          </div>
        </transition>
      </template>
    </div>
    <!-- 企业介绍  animate__animated animate__fadeInUp -->
    <div class="about_bg flex" id="about_bg">
      <div class="about_box">
        <div class="about_line"></div>
        <div
          class="fwhite mt50"
          style="font-size: 56px;"
          v-if="language != 'EN'"
        >{{about_info.title_little}}</div>
        <div class="f36 fwhite mt30">{{about_info.title}}</div>
      </div>
      <div class="about_info">
        <div class="f36 black fb">{{about_info.article.title}}</div>
        <div
          class="pct80 f16 gray mt30 lh30 container"
          style="height: 200px; overflow:scroll; overflow-x:hidden"
        >
          <div v-html="about_info.article.info"></div>
        </div>

        <div class="mt20 flex">
          <div
            :class="index < about_info.label.length - 1 ?'mr100':''"
            v-for="(item,index) in about_info.label"
            :key="index"
          >
            <div class="flex flexa">
              <div class="f60 dgray fb">
                <animate-number ref="myNum" from="10" :to="item.A" duration="4000"></animate-number>
                {{item.A1}}
              </div>
              <div class="tc ml10 f14">
                <span class="block">/</span>
                <span class="block">{{item.B}}</span>
                <span class="block">/</span>
              </div>
            </div>
            <p class="tc f16 mt5">{{item.C}}</p>
          </div>

          <!--
            <div class="mr100">
              <div class="flex flexa">
                <div class="f60 dgray fb">
                  <animate-number ref="myNum0" from="10" to="47" mode="manual"></animate-number>
                </div>
                <div class="tc ml10 f14">
                  <span class="block">/</span>
                  <span class="block">{{language == 'EN'?'Year':'年'}}</span>
                  <span class="block">/</span>
                </div>
              </div>
              <p class="tc f16 mt5">47年的历史沉淀</p>
            </div>

            <div class="mr100">
              <div class="flex flexa">
                <div class="f60 dgray fb">
                  <animate-number ref="myNum1" from="100" to="500" mode="manual"></animate-number>+
                </div>
                <div class="tc ml10 f14">
                  <span class="block">/</span>
                  <span class="block">名</span>
                  <span class="block">/</span>
                </div>
              </div>
              <p class="tc f16 mt5">500+名高端专业人才和技术骨干</p>
            </div>

            <div class="">
              <div class="flex flexa">
                <div class="f60 dgray fb">
                  <animate-number ref="myNum2" from="010" to="100" mode="manual"></animate-number>+
                </div>
                <div class="tc ml10 f14">
                  <span class="block">/</span>
                  <span class="block">家</span>
                  <span class="block">/</span>
                </div>
              </div>
              <p class="tc f16 mt5">100+家优秀合作伙伴</p>
            </div>
          -->
        </div>
      </div>
    </div>

    <!-- 定位 -->
    <div class="flex flexb loc_box" id="loc_box" >
      <!-- 左边方框数据 -->
      <div class="loc_lt" >
        <template>
          <div
            class="loc_lt_box animate__animated wow animate__bounceInLeft"
            data-wow-duration="2s"
            :style="item.css"
            v-for="(item,index) in magic_l"
            :key="index"
          >
            <template v-if="item.margin == 'left'">
          
              <img :src="item.cover_img" class="img_hover" style="width:100%;height:100%" />
              <div class="loc_lt_txt">
                <p class="f24">{{item.title}}</p>
                <p class="f15 mt5">{{item.info}}</p>
              </div>
            </template>
          </div>
        </template>
        
          <!-- <div class="loc_lt_box" style="top:0;right:0;width:14.58vw; height: 25vh;">
            <img src="@/assets/images/h4.png" width="100%">
            <div class="loc_lt_txt"><p class="f24">价值</p><p class="f16 mt5">48小时覆盖中国及周边地区重要港口</p></div>
          </div>

          <div class="loc_lt_box" style="width:14.58vw; height: 25vh; bottom:0;right:0;background: #0B2143;">
             <div class="loc_lt_txt"><p class="f24">使命</p><p class="f16 mt5">明确“节能降耗、杜绝污染、绿色修船”为环保理念，为客户提供符合安全质量标准的服务</p></div>
          </div>


          <div class="loc_lt_box" style="width:13.54vw; height: 9.25vh; top:0;right:21.35vw;background: #0B2143;">
             <div class="loc_lt_txt"><p class="f24">构架</p><p class="f16 mt5">全球发展，沿海布局</p></div>
          </div>

          <div class="loc_lt_box" style="width:12.5vw;height:17.59vh;top:10.18vh;right:15.1vw;">
            <img src="@/assets/images/h3.png" width="100%">
            <div class="loc_lt_txt"><p class="f24">战略</p><p class="f16 mt5">优化流程、提高效率管理精细</p></div>
          </div> -->
         
          <!-- 上面是后端数据 -->
        <div
          class="loc_lt_box"
          style="width:5.7vw; height: 9.4vh; top:0;right:15.1vw;background: #ddd;"
        ></div>
        <div
          class="loc_lt_box"
          style="width:5.6vw; height: 9.9vh; top:29vh;right:15.1vw;background: #1C4383;"
        ></div>
        <div
          class="loc_lt_box"
          style="width:5.6vw; height: 11vh; bottom:0;right:15.1vw;background: #F6F6F6;"
        ></div>
        <div
          class="loc_lt_box"
          style="width:6vw; height: 4.9vh; bottom:0;right:21.5vw;background: #ddd;"
        ></div>
        <div
          class="loc_lt_box"
          style="width:6vw; height:16vh; bottom:6vh;right:21.5vw;background: #F6F6F6;"
        ></div>
        <div
          class="loc_lt_box"
          style="width:6.7vw; height: 14.7vh; bottom:0;right:28.1vw;background: #F6F6F6;"
        ></div>
        <div
          class="loc_lt_box"
          style="width:6.7vw; height:  14.7vh; bottom:14.8vh;right:28.1vw;background: #ddd;"
        ></div>
        <!-- width:110px;height:120px -->
        <div
          class="loc_lt_box"
          style="width:6.7vw; height: 11.11vh; bottom:29.6vh;right:28.1vw;background: #F6F6F6;"
        ></div>
      </div>
      <!-- 中间视频 -->
      <div class="loc_ce animate__animated animate__bounceIn wow" >
        <video id="video_small" muted autoplay loop :src="magic_c[0].video"></video>

        <!-- @click="playVideo()" -->
        <!-- <img :src="magic_c[0].cover_img" id="play_bg" width="100%" v-if="is_show_loc" /> -->
        <!-- <img
          src="@/assets/images/ico_play.png"
          id="playV"
          width="90"
          v-if="is_show_loc"
          @click="playVideo()"
        />-->
        <div class="loc_ce_txt" v-if="is_show_loc">
          <p class="f24">{{magic_c[0].title}}</p>
          <p class="f15 mt5">{{magic_c[0].info}}</p>

          <!--
            <p class="f16 mt5" v-if="language == 'EN'">Modern ship enterprises focusing on ship repair and refitting</p>
            <p class="f16 mt5" v-else>以船舶修理、改装为主的现代化船舶企业</p>
          -->
        </div>
      </div>
      <!-- 右边显示方框 -->
      <div class="loc_rt" >
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          :style="item.css"
          v-for="(item,index) in magic_r"
          v-if="item.margin == 'right'"
          :key="index"
        >
          <img :src="item.cover_img" width="100%" height="100%" class="img_hover" />
          <div class="loc_lt_txt">
            <p class="f24 ml10">{{item.title}}</p>
            <p class="f15 mt5 ml10">{{item.info}}</p>
          </div>
        </div>

                
          <!-- <div class="loc_lt_box" style="width:14.06vw;height:25vh;bottom:0;left:0;">
            <img src="@/assets/images/h1.png" width="100%" height="100%">
            <div class="loc_lt_txt"><p class="f24">宗旨</p><p class="f16 mt5">坚守“追求卓越，铸就品牌”</p></div>
          </div>

          <div class="loc_lt_box" style="width:12.4vw;height:14.9vh;top:0;left:14.58vw;">
            <img src="@/assets/images/h2.png" width="100%" height="100%">
            <div class="loc_lt_txt"><p class="f24">特点</p><p class="f16 mt5">打造高标准的现代化修船企业</p></div>
          </div>

          <div class="loc_lt_box" style="width:14.06vw; height:12.96vh; bottom:25.92vh;left:0;background: #0B2143;">
             <div class="loc_lt_txt"><p class="f24">模式</p><p class="f16 mt5">全球合作共创未来</p></div>
          </div>

          <div class="loc_lt_box" style="width:20.3vw; height: 18.98vh;bottom:0;left:14.58vw;background: #0B2143;">
             <div class="loc_lt_txt"><p class="f24">荣誉</p><p class="f16 mt5">CCS、LR、BV、NK、DNV等著名验船机构和船东的认可</p></div>
          </div>

          <div class="loc_lt_box" style="width:12.36vw; height: 8.42vh;bottom:26.85vh;left:14.58vw;background: #0B2143;">
             <div class="loc_lt_txt"><p class="f24">理念</p><p class="f16 mt5">薪火相传，继往开来</p></div>
        </div> -->
        <!-- 上面是后端的代码 -->
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:7.8vw; height: 11.1vh; top:0;left:0;background: #F6F6F6;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:5.72vw; height: 6.48vh; top:0;left:8.33vw;background: #ddd;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:5.72vw; height: 3.7vh; top:7.4vh;left:8.33vw;background: #ddd;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:5.93vw; height: 5.55vh; bottom:20.37vh;left:14.58vw;background: #ddd;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:5.93vw; height: 5.55vh; bottom:20.37vh;left:21.14vw;background: #1C4383;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:6.9vw;; height: 9.25vh; bottom:20.37vh;left:27.6vw;background: #F6F6F6;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:6.9vw;; height: 8.5vh; bottom:30.5vh;left:27.6vw;background: #ddd;"
        ></div>
        <div
          class="loc_lt_box animate__animated wow animate__bounceInRight wow"
          data-wow-duration="2s"
          style="width:6.9vw; height: 11.11vh; top:0;left:27.6vw;background: #F6F6F6;"
        ></div>
      </div>
    </div>

    <!-- 新闻中心 -->
    <div class="news_box mb40">
      <div class="title fff mr-auto">
        <p class="f36 fwhite mb5" v-if="language != 'EN'">新闻中心</p>
        <p class="fwhite" :class="language == 'EN'?'f36':'f22'">News Center</p>
      </div>

      <div class="wth1400 mr-auto flex flexb mt40">
        <div class="news_pic" @click="goNewsDetail(news_list[0].id)">
          <!-- <img src="@/assets/images/pic_news.png" width="100%"> -->
          <img :src="news_list[0].cover_img" width="100%" />
          <div class="tips" style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">{{news_list[0].info_notag}}</div>
        </div>

        <div class="news_info">
          <div
            class="news_list"
            @click="goNewsDetail(item.id)"
            v-for="(item,index) in news_list"
            :key="index"
          >
            <template v-if="index >= 0">
              <div class="flex flexa flexb" style="overflow: hidden;margin-bottom:27px">
                <div class="ell f24" style="width:480px">{{item.title}}</div>
                <div class="f16 ">{{item.addtime}}</div>
              </div>
              <div class="f16 ht60 lh30 ofh" style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">{{item.info_notag}}</div>
            </template>
          </div>
        </div>
      </div>

      <div class="more fff mr-auto mt30" @click="goUrl('news')">
        <div class="ico">
          <img src="@/assets/images/ico_right.png" width="70%" />
        </div>
        <div class="ico_txt">{{language == 'EN'?'More+':'查看详情'}}</div>
      </div>
    </div>

    <!-- 案例故事 -->
    <div class="wth1400 mr-auto mb40">
      <div class="flex flexa flexb">
        <div class="title">
          <p class="f36 black mb5" v-if="language != 'EN'">案例故事</p>
          <p class="black" :class="language == 'EN'?'f36':'f22'">Case Stories</p>
        </div>
        <div class="more" @click="goUrl('business',2)">
          <div class="ico">
            <img src="@/assets/images/ico_right_w.png" width="70%" />
          </div>
          <div class="ico_txt">{{language == 'EN'?'More+':'查看详情'}}</div>
        </div>
      </div>

      <div class="case_box">
        <div class="case_info">
          <div class="case_pic">
            <img :src="case_list.cover_img" width="100%" />
          </div>
          <!-- <div class="case_pic"><img src="@/assets/images/fac_pic.png" width="100%"></div> -->
          <div class="case_txt">
            <div class="case_txt_title">{{case_list.title}}</div>
            <div class="case_txt_cont" v-html="case_list.info">
              <!-- v-html="case_list.info" -->
              <!-- <p style="text-indent: 2em;">公司现有20万吨级干船坞一座（310米X 55米）、7万吨级干船坞一座（235米X40米）、4个修船码头总长近1000米，以及其它完善的修船设备设施。年修船 180 余艘，涵盖散货，集装箱，油轮，PCC 滚装船，LPG 等多种船型。现已完成脱硫塔系统改装项目50余艘，压载水系统改装300余艘。 </p>
              <p class="mt20" style="text-indent: 2em;">公司现有职工500多人，外协队伍1000多人，培养和引进了紧缺的高端专业人才和技术骨干，以丰富的修船经验、精湛的专业技术、一流的服务品质为企业创造了核心的竞争力，得到了CCS、LR、BV、NK、DNV-GL等世界主流船级社及船东的认可。</p>-->
            </div>
          </div>
        </div>
        <div  style="text-align: center; margin-top:61px">
          <p class="f36 black mb5" v-if="language != 'EN'">我们的客户</p>
          <p class="black" :class="language == 'EN'?'f36':'f22'">Our Customers</p>
        </div>
        <div class="wth1300 mr-auto flex flexb flexw mt40">
          <div class="bot_ico awow bounceInRight" data-wow-duration="2s" v-for="(item,index) in pplogolist" :key="index">
            <img :src="item.cover_img" height="80%" />
          </div>
          <!-- <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo2.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo3.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo4.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo5.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo6.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo7.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo8.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo9.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo10.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo11.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo12.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo13.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo14.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo15.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo16.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo17.png" height="80%" />
          </div>
          <div class="bot_ico wow bounceInRight" data-wow-duration="2s">
            <img src="@/assets/images/bot_logo/logo18.png" height="80%" />
          </div> -->
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import {
  getBanner,
  indexAboutUs,
  getMagic,
  getArticleListByFunc,
  getTopArticleInfoByFunc,
} from "@/request/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import "animate.css";
require("animate.css/animate.min.css");
import { WOW } from "wowjs";
export default {
  name: "Index",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      show: false, //控制弹窗视频的显示
      language: localStorage.getItem("language") || "CH",
      keyword: "",
      // https://www.runoob.com/try/demo_source/movie.mp4
      video_url: "",
      banner_list: [],
      is_show_loc: true,
      swiperOption: {
        autoplay: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 4000
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
          type: "bullets"
        }
      },
      scrollTop: "",
      numTop: "",
      numTop2: "",
      about_info: [],
      magic_l: [],
      magic_c: [],
      magic_r: [],
      news_list: [],
      case_list: {},
      pplogolist:[]
    };
  },
  created() {
    // var video = document.getElementById("video");
    // video.play();

    this.getBanner();
    this.getAboutUs();
    this.getMagic();
    this.getNews();
    this.getCase();
    this.getppFun()
  },
  computed: {
    Swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  beforeMount() {
    //读取缓存
    console.log(JSON.parse(sessionStorage.getItem("show")));
    this.show = JSON.parse(sessionStorage.getItem("show")).show;
    console.log("缓存数据", JSON.parse(sessionStorage.getItem("show")).show);
  },
  mounted() {
    // let targetbox= document.getElementById('about_bg');
    // this.numTop = targetbox.offsetTop;

    // let targetbox2 = document.getElementById('loc_box');
    // this.numTop2 = targetbox2.offsetTop;
    // this.$nextTick(() => {
    this.$refs.videoPlayer.muted = false;
    this.$refs.videoPlayer.play();
    // });
    window.addEventListener("scroll", this.handleScroll, true);
    new this.$wow.WOW().init();
    // this.$refs.video.src = 'https://www.runoob.com/try/demo_source/movie.mp4'
    // let targetbox = document.getElementById("about_bg");
    // this.numTop = targetbox.offsetTop;
    // let targetbox2 = document.getElementById("loc_box");
    // this.numTop2 = targetbox2.offsetTop;
    // new WOW({ live: false }).init();
    // wow初始化
    this.$nextTick(() => {
      const wow = new WOW({
        boxClass: "wow", // default
        animateClass: "animated", // default
        offset: 10, // default
        mobile: true, // default
        live: false,
        // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
        callback: function(box) {
          console.log("WOW: animating <" + box.tagName.toLowerCase() + ">");
        }
      });
      wow.init();
    });

    window.addEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    scrollTop: function() {
      console.log("滚动距离", this.scrollTop);
      var that = this;
      if (this.scrollTop > this.numTop - 200 && this.scrollTop < this.numTop2) {
        that.numberStart();
      }
    }
  },
  methods: {
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      this.scrollTop = top;
      console.log("滚动距离", this.scrollTop);
      if (top > 600) {
        console.log("触发滚动", top);
        // let data = JSON.parse(JSON.stringify(this.about_info))
        // this.data
      }
    },
    moveBtn() {
      // 点击播放按钮的事件
      this.show = true;
    },
    getBanner() {
      var that = this;
      getBanner({
        func: "index"
      })
        .then(res => {
          that.video_url = res.data.video;
          if (that.language == "EN") {
            that.video_url = res.data.video.split("?")[0];
          }
          that.banner_list = res.data.banner;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAboutUs() {
      var that = this;
      indexAboutUs()
        .then(res => {
          that.about_info = res.data;
          // console.log('测试数据',that.about_info);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getMagic() {
      var that = this;
      getMagic()
        .then(res => {
          var data = res.data.magic;
          that.magic_l = data.filter(item => {
            if (item.margin == "left") {
              return item;
            }
          });

          that.magic_c = data.filter(item => {
            if (item.margin == "center") {
              return item;
            }
          });

          that.magic_r = data.filter(item => {
            if (item.margin == "right") {
              return item;
            }
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    numberStart() {
      this.$refs.myNum[0].start();
      this.$refs.myNum[1].start();
      this.$refs.myNum[2].start();
    },
    playVideo() {
      var video = document.getElementById("video_small");
      if (this.is_show_loc) {
        this.is_show_loc = false;
        video.play();
      } else {
        this.is_show_loc = true;
        video.pause();
      }
    },
    getNews() {
      var that = this;
      getArticleListByFunc({
        func: "News",
        limit: 3,
        page: 0
      })
        .then(res => {
          that.news_list = res.data.article_list;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    goUrl(url, tab) {
      if (tab) {
        this.$router.push({ path: "/" + url, query: { tab: tab } });
      } else {
        this.$router.push({ path: "/" + url });
      }
    },
    goNewsDetail(id) {
      //新闻详情页
      this.$router.push({ path: "/newsDetail", query: { id: id } });
    },
    // 获取案例文章
    getCase() {
      var that = this;
      getTopArticleInfoByFunc({
        func: "Anli"
      })
        .then(res => {
          // that.case_list = res.data.article_info;
          this.case_list = res.data.article_info;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取客户品牌
    getppFun(){
      var that = this;
      getArticleListByFunc({
        func: "Kehu",
        limit:18
      })
        .then(res => {
          that.pplogolist = res.data.article_list;
        
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    closeFun() {
      console.log(this.$refs.videoPlayer);
      sessionStorage.setItem("show", JSON.stringify({ show: false }));
      this.show = false;
    }
  }
};
</script>

<style scoped>
.container::-webkit-scrollbar {
  display: none;
}
.movie_v {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: red; */
  z-index: 9999;
}
.movie_box {
  position: fixed;
  /* left: 50%;
  top: 50%; */
  border-radius: 50%;
  right: 30px;
  top: 20px;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10000;
}
.box_close {
  /* float: right; */
  /* margin: 30px 20px 0 0; */
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-image: url(../../assets/images/det.png);
  background-size: 100% 100%;
  font-size: 20px;
  text-align: center;
  color: #d5d4d4;
}

.video_btn {
  position: relative;
}
.move_btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  background-size: 100% 100%;
}
.logo_c {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100px;
  height: 100px;
  background: url(../../assets/images/video_logo.png) no-repeat;
  background-size: 100% 100%;
  opacity: 0.6;
}
.top {
  position: relative;
  width: 100%;
  height: 950px;
  overflow: hidden;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.top >>> .swiper-pagination {
  bottom: 25px;
}

.top >>> .swiper-pagination-bullet {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: #f5f5f5 !important;
  display: inline-block;
  border-radius: 100%;
  opacity: 0.85;
  margin: 0 10px;
}

.top >>> .swiper-pagination-bullet-active {
  background-color: #fff !important;
  width: 25px;
  border-radius: 8px;
  opacity: 1;
}
#video,
#video_small {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.about_bg {
  background: url(../../assets/images/bg.png) no-repeat;
  background-size: 100% 100%;
}
.about_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 440px;
  height: 540px;
  margin-left: 100px;
  box-sizing: border-box;
  padding-left: 50px;
  background: url(../../assets/images/pic_about.jpg) no-repeat;
  background-size: 100% 100%;
}
.about_line {
  width: 80px;
  height: 5px;
  background: #ffffff;
}
.about_info {
  width: calc(100% - 540px);
  box-sizing: border-box;
  padding: 90px 80px 0 80px;
}
.loc_box {
  /* width: 100vw; */
  height: 50.9vh;
  overflow: hidden;
}
.loc_lt,
.loc_rt {
  position: relative;
  width: calc((100vw - 30.2vw) / 2);
  height: 50.9vh;
  overflow: hidden;
}
.loc_lt_box {
  position: absolute;
  overflow: hidden;
}
.loc_lt_box:hover {
  box-shadow: 0px 0px 15px 10px rgba(0, 0, 0, 0.2);
}
.loc_lt_box:hover .img_hover {
  width: 120% !important;
  height: 120% !important;
  /* animation: move 1s linear forwards; */
  transition: all 1s;
}

.loc_lt_txt {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 15px;
  line-height: 20px;
  color: #fff;
}
.loc_ce {
  position: relative;
  width: 28.6vw;
  height: 50.9vh;
  overflow: hidden;
}
.loc_ce #video_small {
  width: 28.6vw;
  height: 50.9vh;
}
.loc_ce #play_bg {
  position: absolute;
  top: 0;
  left: 0;
}
.loc_ce #playV {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -45px;
  margin-left: -45px;
}
.loc_ce .loc_ce_txt {
  position: absolute;
  top: 30px;
  left: 30px;
  color: #fff;
  width: 14vw;
  line-height: 30px;
}
.news_box {
  padding: 30px 0;
  width: 100%;
  background: url(../../assets/images/bg_news.jpg) no-repeat;
  background-size: 100% 100%;

}
.news_pic {
  position: relative;
  width: 625px;
  height: 395px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
}
.news_pic img {
  min-height: 100%;
}
.news_pic .tips {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  max-height: 103px;
  overflow: hidden;
  padding: 12px 15px;
  color: #fff;
  font-size: 15px;
  line-height: 28px;
  background: rgba(11, 33, 67, 0.7);
  box-sizing: border-box;
}
.news_info {
  width: 700px;
}
.news_list {
  position: relative;
  color: #fff;
  padding-left: 60px;
  padding-bottom: 45px;
  border-left: 2px solid #fff;
  cursor: pointer;
}
.news_list:after {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: -9px;
}
.title {
  position: relative;
  padding: 20px 0;
  text-align: center;
  width: 325px;
  box-sizing: border-box;
}
.title:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 2px;
  background: #222;
}
.title.fff:before {
  background: #fff;
}
.title:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 120px;
  height: 2px;
  background: #222;
}
.title.fff:after {
  background: #fff;
}
.more {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 160px;
  border: 1px solid #ddd;
  border-radius: 10px;
  height: 50px;
  cursor: pointer;
  overflow: hidden;
}
.more.fff {
  border: 1px solid #fff;
}
.more .ico {
  width: 70px;
  height: 50px;
  border-radius: 0 10px 10px 0;
  overflow: hidden;
  background: #ddd;
  text-align: center;
}
.more.fff .ico {
  background: #fff;
}
.more .ico_txt {
  padding: 0 15px;
  font-size: 15px;
  color: #999;
}
.more.fff .ico_txt {
  color: #fff;
}
.case_box {
  border-radius: 20px;
  border: 2px solid #d5d4d4;
  padding-bottom: 20px;
  margin-top: 90px;
}
.case_info {
  display: flex;
  margin-top: -50px;
}
.case_pic {
  width: 800px;
  border-radius: 15px;
  margin-left: -2px;
  overflow: hidden;
}
.case_txt_title {
  width: 450px;
  background-color: #fff;
  text-align: center;
  padding-left: 50px;
  line-height: 100px;
  font-size: 24px;
  color: #000;
}
.case_txt_cont {
  width: 500px;
  background-color: #fff;
  padding-left: 50px;
  font-size: 16px;
  line-height: 30px;
  color: #999;
  margin-top: 20px;
}
.bot_ico {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190px;
  height: 90px;
  border-radius: 8px;
  background-color: #f6f6f6;
  margin-bottom: 30px;
  margin-right: 20px;
  /* -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%); */
  /* filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); */
  /* filter: gray; */
}
.bot_ico:nth-child(6n) {
  margin-right: 0;
}
.bot_ico:hover {
  background-color: #fff;
  box-shadow: 3px 3px 5px #ccc;
  -webkit-filter: none;
  -moz-filter: none;
  -ms-filter: none;
  -o-filter: none;
  filter: none;
  filter: none;
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/views/pc/index.vue